import BackButton from '../../components/BackButton';
import LocationSettingsCard from './LocationSettingsCard';

/**
 * صفحة إعدادات الموقع المستقلة — متاحة للجميع (ضيف أو مسجّل دخول).
 * تعيد استخدام LocationSettingsCard لعرض المحتوى.
 */
export default function LocationSettings() {
  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-6" dir="rtl">
      <div className="max-w-lg mx-auto pt-6">
        <div className="mb-6">
          <BackButton to={-1} />
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-1">إعدادات الموقع</h1>
        <p className="text-slate-600 text-sm mb-6">
          تفعيل الموقع يساعد في عرض المصورين القريبين منك وتحديد موقعك على الخريطة عند الحجز. لا تحتاج لتسجيل الدخول.
        </p>

        <LocationSettingsCard />
      </div>
    </div>
  );
}
